import React from "react";
import { pick } from "lodash";
import "./responsiveImage.scss";

export const ResponsiveImage = props => {
  const styles = pick(props, ["height"]);
  return (
    <div
      data-component="responsiveImage"
      style={{ backgroundImage: `url(${props.src})`, ...styles }}
    />
  );
};
